import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from 'constants/query-keys';
import { getNextDeliveryInterval } from 'services/AddressService';

import type { IDeliveryInterval, ReactQueryOptions } from 'types';

export const useNextDeliveryInterval = (
  addressToken: string | undefined,
  isAuthenticated: boolean,
  queryOptions: ReactQueryOptions<IDeliveryInterval> = {}
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.NEXT_DELIVERY_INTERVAL, addressToken || 'no-token'],
    queryFn: () => getNextDeliveryInterval(addressToken, isAuthenticated),
    ...queryOptions
  });
};
